export const MAX_FLOATING_POINTS = 8;

export const DEFAULT_NOMINAL_VALUE = 1;
